<template>
<div class="info">
	<Form :label-width="120" class="mt15">
		<FormItem label="保障凭证号：" class="w600">
	        {{info.guaranteeNo}}
			<a :href="info.electronicPolicyUrl" v-if="info.electronicPolicyUrl" target="_blank" class="ml20">查看保单</a>
	    </FormItem>
	    <FormItem label="保障状态：" class="w600">
	        {{info.effectiveStatusDesc}}
	    </FormItem>
		<FormItem label="保单起期：" class="w600">
			{{info.effectiveDateStart}}
		</FormItem>
		<FormItem label="保单止期：" class="w600">
			{{info.effectiveDateEnd}}
		</FormItem>
		<FormItem label="保费：" class="w600">
			{{info.premium}}元
		</FormItem>
		<FormItem label="投保单：" class="w600" v-if="info.productCode=='TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_PEOPLE'">
              {{ info.fileList[0].fileName }}
              <a :href="info.fileList[0].fileUrl" target="_blank" rel="opener" class="ml15">查看</a>
              <a @click="showImg" class="ml15">更多</a>
		</FormItem>
	</Form>
	<Modal
        v-model="modal"
        title="投保单"
        :mask-closable="false"
        width="60%">
          <Table border :columns="columns" :data="info.fileList">
              <template slot-scope="{ row }" slot="action">
				<a :href="row.fileUrl" rel="opener" target="_blank">查看</a>
              </template>
          </Table>
		  <div slot="footer">

		  </div>
    </Modal>
</div>
</template>
<script>
export default {
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
	},
	data(){
		return {
			modal:false,
			modal: false,
			columns:[
				{title:'操作时间',key:'createTime'},
				{title:'文件名',key:'fileName'},
				{title:'操作',slot: 'action'},
			]
		}
	},
	methods:{
		showImg(){
			this.modal = true;
		}
		// renew () {
		// 	this.$router.push(`/installer/fillin-order/${this.$route.params.id}?hrCode=${this.info.hrCode}`)
		// }
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/common/PolicyBasicInfoForCommon.vue